import React, { Component } from 'react';
import {Provider} from 'react-redux';
import {statsReducer, uploadReducer, errorReducer, authReducer, coffeeReducer, onlineReducer, ecommReducer} from './reducers/reducers';
import {combineReducers, createStore} from 'redux';
import {FirebaseAPIContainer} from './components/containers/firebaseAPIContainer';
import {ModalContainer} from './components/containers/modalContainer';
import {AppContainer} from './components/containers/appContainer';

const allReducers = combineReducers({
  coffeeReducer,
  authReducer,
  onlineReducer,
  ecommReducer,
  errorReducer,
  uploadReducer,
  statsReducer
})

const store=createStore(allReducers);

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <div>
          <ModalContainer />
          <FirebaseAPIContainer />
          <AppContainer />
        </div>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/App.js